import { forwardRef, useImperativeHandle } from 'react'

import type { PlayerBackendProps, PlayerHandle } from '../types'

// 占位空壳：实现与 html-video 后端相同的 PlayerHandle / 事件回调契约，
// 但不接入任何流媒体库，句柄方法均为 no-op，仅渲染占位元素。
// 将来接入真实 shaka-player 时替换此文件，context 与胶水层无需改动。
const ShakaPlayer = forwardRef<PlayerHandle, PlayerBackendProps>(({ source, className }, ref) => {
  useImperativeHandle(
    ref,
    () => ({
      play: () => undefined,
      pause: () => undefined,
      seek: () => undefined,
      setVolume: () => undefined,
      setMuted: () => undefined,
      setPlaybackRate: () => undefined,
    }),
    [],
  )

  return <div className={className} data-shaka-placeholder data-src={source.src} />
})

ShakaPlayer.displayName = 'ShakaPlayer'

export { ShakaPlayer }
